import { Subject } from 'rxjs';
const subject = new Subject();
export const loadingService = {
    setloader: loading => subject.next(loading),
    clearloader: () => subject.next(),
    getloader: () => subject.asObservable()
}